import React from 'react';

const Stroked: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const ShadowIcon: React.FC = () => (
  <Stroked>
    <rect x="5" y="5" width="7" height="11" rx="1" />
    <path d="M12 16l8 4H6l-1-4z" fill="currentColor" opacity="0.6" stroke="none" />
    <path d="M3 20h18" />
  </Stroked>
);

export const AmbientOcclusionIcon: React.FC = () => (
  <Stroked>
    <circle cx="12" cy="10" r="6" />
    <path d="M7.2 13.6a6 6 0 0 0 9.6 0" strokeWidth={3} opacity="0.55" />
    <path d="M4 20h16" />
  </Stroked>
);

export const UnderLightIcon: React.FC = () => (
  <Stroked>
    <path d="M12 21v-3M8.5 18h7" />
    <path d="M9 14.5a4 4 0 1 1 6 0c-.4.4-.9.9-1 1.5h-4c-.1-.6-.6-1.1-1-1.5Z" />
    <path d="M5 8l1.5 1M19 8l-1.5 1M12 4V2" />
  </Stroked>
);

export const PlatformIcon: React.FC = () => (
  <Stroked>
    <path d="M3 17l9 4 9-4-9-4-9 4Z" />
    <path d="M9 13V8h6v5M12 4v3" />
  </Stroked>
);

export type MousePart = 'left' | 'right' | 'wheel';

/** A mouse with the button a gesture uses filled in. */
export const MouseIcon: React.FC<{ part?: MousePart }> = ({ part }) => (
  <Stroked>
    <rect x="6" y="3" width="12" height="18" rx="6" />
    <path d="M12 3v7M6 10h12" />
    {part === 'left' && <path data-part="left" d="M12 3a6 6 0 0 0-6 6v1h6V3Z" fill="currentColor" stroke="none" />}
    {part === 'right' && <path data-part="right" d="M12 3a6 6 0 0 1 6 6v1h-6V3Z" fill="currentColor" stroke="none" />}
    {part === 'wheel' ? (
      <rect data-part="wheel" x="10.6" y="5.5" width="2.8" height="4" rx="1.4" fill="currentColor" stroke="none" />
    ) : (
      <path d="M12 6v2.5" strokeWidth={2.2} />
    )}
  </Stroked>
);
